module.exports = __webpack_public_path__ + "295bf282af805764713de0578fb2355e.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/animals/Goat1.jpg
// module id = 3279
// module chunks = 0